export const NAV_MOCK = {
  items: [
    { text: "Ingresso industriale", payload: "/", classes: "is-current" },
    { text: "Ingresso civile", payload: "/"},
    { text: "Preaccumulo", payload: "/" },
    { text: "Sedimentazione primaria", payload: "/" },
    { text: "Denitrificazione", payload: "/" },
    { text: "Sedimentazione biologica", payload: "/" }
  ],
}